import { captureMessageForSentry } from '@/helpers/sentry-helper';
import { UserSearches, UserState } from '@/stores/user.store';
import LocalForage from 'localforage';

export const STORAGE_MIGRATION_REVISION = 6;

/**
 * check if user is set at least, because it will always be set with the new LocalForage instance.
 * if it isn't, transfer all non-namespaced (keys with a `/`) over to LocalForage instance.
 */

export async function needsLocalStorageMigration() {
	const user = (await LocalForage.getItem('user')) as Partial<UserState>;
	return user && user.storageMigratedRevision! < STORAGE_MIGRATION_REVISION;
}

export async function migrateLocalStorage() {
	const user = (await LocalForage.getItem('user')) as Partial<UserState>;

	// Sentry logging to see if this function is still in use
	captureMessageForSentry(`migrateLocalStorage: v${STORAGE_MIGRATION_REVISION}`, {
		where: '[migrate-local-storage.ts]',
	});

	// We need to use ts-ignore here since in new store version recentlyVisitedTitleIds: string[], but in old
	// store version recentlyVisitedTitles: VisitedTitle[]
	//@ts-ignore
	const recentlyVisitedTitleIds = (user.searches?.recentlyVisitedTitles?.map(title => title.jw_entity_id) ||
		[]) as string[];

	const searches: UserSearches = {
		recentSearchTerms: user.searches?.recentSearchTerms || [],
		recentlyVisitedTitleIds,
	};

	const userContent: Partial<UserState> = {
		...user,
		searches,
	};

	// update migration revision
	await LocalForage.setItem('user', {
		...userContent,
		storageMigratedRevision: STORAGE_MIGRATION_REVISION,
	});
}
